import { Addon } from "../../api/entities/Addon";
import {
  EuiButton,
  EuiCard,
  EuiFlexGroup,
  EuiFlexItem,
  EuiSpacer,
  EuiText,
} from "@elastic/eui";
import { GetAddonPrice } from "../../utils/ProductUtils";
import { NumberToCurrency } from "../../utils/Formatters";

export interface IAddonDetailsCard {
  addon: Addon;
  onAddonSelected?: () => void;
  productGroupId?: string;
  buttonText?: string;
}

export const AddonDetailsCard: React.FC<IAddonDetailsCard> = (props) => {
  const price = GetAddonPrice(props.addon, props.productGroupId);

  return (
    <EuiCard
      title={props.addon.name}
      description={props.addon.description}
      footer={
        <>
          <EuiSpacer size="s" />
          <EuiFlexGroup direction="column" gutterSize="l">
            {price > 0 && (
              <EuiFlexItem grow={false}>
                <EuiText>{NumberToCurrency(price)}</EuiText>
              </EuiFlexItem>
            )}
            {props.addon.price > 0 && price !== props.addon.price && (
              <EuiFlexItem grow={false}>
                <EuiText>
                  (${(props.addon.price - price).toLocaleString()} saved)
                </EuiText>
              </EuiFlexItem>
            )}
            <EuiFlexItem>
              <EuiButton fullWidth onClick={props.onAddonSelected}>
                {props.buttonText ? props.buttonText : "Add"}
              </EuiButton>
            </EuiFlexItem>
          </EuiFlexGroup>
        </>
      }
      style={{ width: 400 }}
    ></EuiCard>
  );
};
